import { useMsal } from "@azure/msal-react";
import createAxiosInstance from "../utils/axiosCustomize";

const UserService = () => {
    const { instance, accounts } = useMsal();
    const axiosInstance = createAxiosInstance(instance, accounts);

    const getUserInfo = () => {
        return axiosInstance.get("/User/userInfo")
    }

    return { getUserInfo }
}

export default UserService;
